import { Search_RequestBody } from '@opensearch-project/opensearch/api';

import { EnumCustomerType } from '@/types';

export const PRODUCTS_SEARCH_QUERY_ID = 'products-search';

/** Must stay in sync with `useSearch` so dehydrated prefetch hits hydrate. */
export const PRODUCTS_SEARCH_STALE_TIME = 1000 * 60 * 1;

export const buildProductsSearchQueryKey = ({
  id,
  storeName,
  customerType,
  inventoryLocationId,
  searchBody,
}: {
  id?: string;
  storeName?: string;
  customerType?: EnumCustomerType;
  inventoryLocationId?: string | null;
  searchBody: Search_RequestBody;
}) => [
  id ?? PRODUCTS_SEARCH_QUERY_ID,
  storeName,
  customerType,
  inventoryLocationId ?? '',
  JSON.stringify(searchBody),
];
